import { ModelRow, StringUtil } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import {
    BlurEvent, ChangeEvent, LayoutProvidedReportDecoratorProps, PanelProcessLastRun, ReportViewerTab
} from "@mcleod/components";
import { AutogenLayoutPaidOfficeSummaryReport } from "./autogen/AutogenLayoutPaidOfficeSummaryReport";

export class PaidOfficeSummaryReport extends AutogenLayoutPaidOfficeSummaryReport {
    private processLog: PanelProcessLastRun = PanelProcessLastRun.create("Email Settlement Summaries");
    public override get reportDecoratorProps(): Partial<LayoutProvidedReportDecoratorProps> {
        const headerRightTools = [];
        if (this.processLog) {
            headerRightTools.push(this.processLog);
        }
        return {
            tabCreationCallback: (tab: ReportViewerTab) => {
                if (tab.reportData.reportName === "exception-report") {
                    tab.imageName = ImageName.documentException;
                }
            },
            doAfterSearch: () => {
                if (this.checkboxEmailSummaries.checked) {
                    this.processLog?.refreshLastProcessedData();
                }
            },
            headerAddlRightTools: headerRightTools
        };
    }


    /** This is an event handler for the onChange event of switchCheckRange. */
    switchCheckRangeOnChange(event: ChangeEvent) {
        const checked = event.newValue;
        this.textboxCheckRangeStart.caption = checked ? "Check Number Start" : "Check Number";
        this.textboxCheckRangeEnd.visible = checked;
        this.labelDash.visible = checked;

        if (!checked) {
            this.textboxCheckRangeEnd.clear();
        }

    }

    /** This is an event handler for the onBlur event of textboxCheckRangeStart. */
    textboxCheckRangeStartOnBlur(event: BlurEvent) {
        this.textboxCheckRangeStart.text = this.formatCheckNumber(this.textboxCheckRangeStart.text);

    }

    /** This is an event handler for the onBlur event of textboxCheckRangeEnd. */
    textboxCheckRangeEndOnBlur(event: BlurEvent) {
        this.textboxCheckRangeEnd.text = this.formatCheckNumber(this.textboxCheckRangeEnd.text);
    }

    formatCheckNumber(number: string): string {
        if (!number) {
            return null;
        }

        if (number.length >= 8) {
            return number;
        }

        return StringUtil.leftPad(number, "0", 8);
    }

    checkboxPostedPaymentsOnChange() {
        if (this.checkboxPostedPayments.checked) {
            this.checkboxEmailSummaries.enabled = true;
        }
        else {
            this.checkboxEmailSummaries.enabled = false;
            this.checkboxEmailSummaries.checked = false;
        }
    }


}